module.exports = __webpack_public_path__ + "static/media/sports-fitness.a3c390d4.svg";